/** @jsx jsx */

import React, {
  useState,
  useRef,
  useContext,
  useEffect,
  useLayoutEffect,
} from 'react';
import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import getBlockById from 'services/apiHelpers/getBlockById';
import { interactionContext } from './interactionContext';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';
import isIE from 'services/isIE';
import isiOS from 'services/isiOS';
import { useSelector } from 'react-redux';
import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import TopicPanelDefaultIcon from 'assets/TopicPanelDefaultIcon.png';
import hexToRGB from 'services/hexToRGB';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import TopicPanel from './TopicPanel';

const { lGrey0, lPink } = colors;

const TopicPortalContainer = props => {
  const topics = getTopics();

  return (
    <div>
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin: 50px 0 50px 0;
        `}
      >
        {topics.map((t: any) => (
          <TopicPanel key={t.id} topic={t} />
        ))}
      </div>
    </div>
  );
};

export default TopicPortalContainer;
